import { computed, isRef, ref, unref } from "@nuxtjs/composition-api";
import { addFavorites, cancelFavorites } from "@/services/product";

import { REQUEST_CODES } from "@/constants/const-http.js";
import useMessage from "../../../composables/useMessage";
import {useToggle} from "@vueuse/core";


export default function useProductFavorite(product_no, defaultValue = false) {
  const [isFavorite, setIsFavorite] = useToggle(defaultValue);
  const Message = useMessage();

  const favoriteIcon = computed(() => {
    return isFavorite.value ? "share-like-active" : "share-like";
  });

  const toggleFavorite = async (isFavorite, product_no) => {
    if (isFavorite) {
      const { code, msg } = await cancelFavorites(
        product_no
      );
      if (code !== REQUEST_CODES.ERROR_OK) {
        Message.error(msg);
        throw new Error(msg);
      }
      setIsFavorite(false);
      Message.success("取消收藏成功");
    } else {
      const { code, msg } = await addFavorites(
        product_no
      );
      if (code !== REQUEST_CODES.ERROR_OK) {
        Message.error(msg);
        throw new Error(msg);
      }
      setIsFavorite(true);
      Message.success("收藏成功");
    }
  }

  async function onToggleFavorite() {
    await toggleFavorite(unref(isFavorite), unref(product_no))
  }
  return {
    isFavorite,

    toggleFavorite,
    onToggleFavorite,
    favoriteIcon
  };
}
